// extracted by mini-css-extract-plugin
export default {"banner":"ExhibitionsBanner_banner__Abt+s"};